<script setup lang="ts">
import type { PropertySeoSection } from '@@/shared/property/seo-link';

const props = defineProps<{
  seoSection: PropertySeoSection
}>();

const { t } = useI18n();
const title = computed(() => {
  if (typeof props.seoSection.title === 'string') return props.seoSection.title;
  if (props.seoSection.title[1]) return t(props.seoSection.title[0], props.seoSection.title[1]);
  return t(props.seoSection.title[0]);
});

const displayAll = ref(false);
const displayShowMore = computed(() => props.seoSection.items.length > 6);
</script>

<template>
  <div>
    <IadTitle
      :text="title"
      tag="h2"
    />
    <ol>
      <PropertySeoLink
        v-for="(item, index) of seoSection.items"
        :key="item.id"
        :display-all
        :item
        :index
      />
    </ol>
    <IadLinkMoreLess
      v-if="displayShowMore"
      v-model="displayAll"
    />
  </div>
</template>
